import { reportingPeriodOptions, statementTypeOptions } from '../constants';
import { ReportingPeriodEnum, StatementTypeEnum } from '../generated-api';

// Returns the human readable label for a given ReportingPeriodEnum value
export const getReportingPeriodLabel = (value: ReportingPeriodEnum) =>
  reportingPeriodOptions.find((o) => o.value === value)?.label ?? 'Full Year';

// Returns the human readable label for a given StatementTypeEnum value
export const getStatementTypeLabel = (value: StatementTypeEnum) =>
  statementTypeOptions.find((o) => o.value === value)?.label ?? '';
